import { useCallback, useEffect, useState } from 'react';
import { fetchLinearTickers, tickersMeta, resolveBybitSymbol } from '../../utils/bybit';
import { fmtPct } from '../../utils/fmt';
import HomeModule from './HomeModule';

/* Funding (Bybit) — BTC, ETH és a kiválasztott coin; leíró, kisbetűs szöveg:
   „−0,0030% / 8 ó · évesítve −3,3% · negatív: a short pozíciók fizetnek a longoknak”.
   Az évesítés a szimbólum saját funding-intervallumával számol (fundingIntervalHour). */

const TTL = 5 * 60 * 1000;

export function fundingLine(rate, intervalH = 8) {
  if (rate == null || !Number.isFinite(rate)) return null;
  const h = intervalH > 0 ? intervalH : 8;
  const pct = rate * 100;
  const annual = pct * (24 / h) * 365;
  const who = rate > 0 ? 'pozitív: a long pozíciók fizetnek a shortoknak'
    : rate < 0 ? 'negatív: a short pozíciók fizetnek a longoknak' : 'nulla: most senki nem fizet';
  return { rate: `${fmtPct(pct, 4)} / ${h} ó`, annual: `évesítve ${fmtPct(annual, 1)}`, who, sign: Math.sign(rate) };
}

export default function HomeFunding({ selectedCoin, user }) {
  const [map, setMap] = useState(null);
  const [meta, setMeta] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(() => {
    setFailed(false);
    fetchLinearTickers(TTL).then(m => { setMap(m); setMeta(tickersMeta()); }).catch(() => setFailed(true));
  }, []);
  useEffect(() => { load(); const t = setInterval(load, TTL); return () => clearInterval(t); }, [load]);

  const rows = [['BTC', 'BTCUSDT'], ['ETH', 'ETHUSDT']];
  const selSym = map && selectedCoin && !['btc', 'eth'].includes(String(selectedCoin.symbol).toLowerCase())
    ? resolveBybitSymbol(selectedCoin.symbol, selectedCoin.current_price, map) : null;
  if (selSym) rows.push([String(selectedCoin.symbol).toUpperCase(), selSym]);

  return (
    <HomeModule id="funding" title="Funding" user={user}
      info="A perpetual szerződések finanszírozási díja. Pozitívnál a long, negatívnál a short pozíciók fizetnek a másik oldalnak, általában 8 óránként. Tartósan magas érték túlfűtött long oldalt jelezhet."
      source="Bybit" at={meta?.at} expectedMs={TTL} stale={meta?.stale} error={failed && !map}
      errorText="A Bybit API most nem elérhető" onRetry={load} className="hfu">
      {rows.map(([label, sym]) => {
        const t = map?.[sym];
        const line = t ? fundingLine(parseFloat(t.fundingRate), Number(t.fundingIntervalHour) || 8) : null;
        return (
          <div key={sym} className="hfu-row">
            <span className="hfu-sym">{label}</span>
            {line ? (
              <span className="hfu-txt">
                <span className={`num ${line.sign > 0 ? 'neg' : line.sign < 0 ? 'pos' : ''}`}>{line.rate}</span>
                {' · '}<span className="num">{line.annual}</span>
                <span className="hfu-who">{line.who}</span>
              </span>
            ) : <span className="hfu-txt">{map ? 'nincs Bybit-perpetual' : failed ? '—' : '…'}</span>}
          </div>
        );
      })}
    </HomeModule>
  );
}
